import { buildScopedI18n } from '../../../../utils/buildScopedI18n';
import configMovementsEsCL from './locales/es-CL.json';
import configMovementsEnUS from './locales/en-US.json';
import configMovementsPtBR from './locales/pt-BR.json';

export const configMovementsI18n = buildScopedI18n({
  esCL: configMovementsEsCL,
  enUS: configMovementsEnUS,
  ptBR: configMovementsPtBR,
});
